import { gql } from '@apollo/client';

const Fragments = {
  scheduleTypeCellParamTemplate: gql`
    fragment scheduleTypeCellParamTemplate on ScheduleTypeCellParamTemplate {
      scheduleTypeCellParamTemplateId
      templateName
      activeYN
    }
  `
};

export default Fragments;
